import { useLocation } from "react-router-dom";
import { getEmployerRegStep } from "@/constants/employerRegistrationSteps";
import { cn } from "@/utils/cn";

export const EmployerRegStepIndicator = () => {
  const location = useLocation();
  const stepInfo = getEmployerRegStep(location.pathname);
  if (!stepInfo) return null;

  const { step, total, label } = stepInfo;

  return (
    <div className="flex flex-col gap-y-2 w-full mb-6">
      <p className="font-clash-display text-base text-medium-dark-grey tracking-[-0.08px]">
        Step {step} of {total} – {label}
      </p>
      <div className="flex gap-[20px] items-center">
        {Array.from({ length: total }).map((_, i) => (
          <div
            key={i}
            className={cn("h-[3px] rounded-[13px] border shrink-0 transition-colors duration-200",
              i + 1 <= step ? "border-transparent" : "border-[#adada7]"
            )}
            style={{
              width: "94px",
              backgroundColor: i + 1 <= step ? "var(--color-primary-button)" : "var(--color-off-white)",
            }}
          />
        ))}
      </div>
    </div>
  );
};
